export default __webpack_public_path__ + "static/media/Nil.e9ae2b5a.png";